import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../ui-common/button/button.component';
import { DialogRef } from '@angular/cdk/dialog';
import { SharedService } from '../data/shared.service';
import { TranslatePipe } from '../data/pipes/translate.pipe';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { PhoneInputComponent } from "../ui-common/phone-input/phone-input.component";

@Component({
  selector: 'app-feature-invalid-phone-verification',
  imports: [CommonModule, ButtonComponent, TranslatePipe, ReactiveFormsModule, PhoneInputComponent],
  templateUrl: './feature-invalid-phone-verification.component.html',
  styleUrl: './feature-invalid-phone-verification.component.scss',
})
export class FeatureInvalidPhoneVerificationComponent {
  dialogRef = inject(DialogRef);
  sharedService = inject(SharedService);
  formBuilder = inject(FormBuilder);

  form: FormGroup;
  errorMessage: string | undefined;

  constructor() {
    this.form = this.formBuilder.group({
      phone: ['', [Validators.required]]
    });
  }

  async submitForm(): Promise<void> {
    const phone = this.form.get('phone')?.value ?? '';
    const phoneNumber = `${phone.trim().startsWith('+') ? '+' : ''}${phone.replace(/\D/g, '')}`;

    this.sharedService.invalidPhoneNumberVerification(phoneNumber).subscribe({
      next: () => {
        this.dialogRef.close();
      },
      error: (errorResponse: HttpErrorResponse) => {
        this.errorMessage = errorResponse.error;
      }
    });
  }
}
